import { mergeSxObject } from '../../helpers'
import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * When you want to display all in uppercase visually
   * @default false
   */
  isUppercase?: boolean

  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<'primary' | 'dhlRed' | 'goGreen'>
}>

/**
 * Our visual H1 for DHL is the biggest available Heading
 */
/**
 * Demos:
 * - [H1](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/story/primitives-typography--h-1)
 *
 */
export const H1 = ({ children, isUppercase, variant = 'primary', sx, ...rest }: Props) => (
  <BaseTypography
    variant="h1"
    color={variant}
    {...rest}
    sx={mergeSxObject(sx, isUppercase ? { textTransform: 'uppercase' } : {})}
  >
    {children}
  </BaseTypography>
)
